import React, { ChangeEvent, forwardRef } from 'react';
import { TextField } from '@mui/material';
import { Item } from 'src/components/Forms/CustomFormulaForm/FormulaCalculator/components/Item';
import {
  Input,
  InputText,
  List,
  Mask,
} from 'src/components/Forms/CustomFormulaForm/FormulaCalculator/components/styled';
import { StrictModeDroppable } from 'src/components/StrictModeDroppable';
import { FormattedCustomFormulaItem, getIconForMetric } from 'src/utils';

interface RowProps {
  row: {
    id: string;
    list: FormattedCustomFormulaItem[];
  };
  inputValue: string;
  option: string;
  hasInput?: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}

export const Row = forwardRef<HTMLDivElement, RowProps>(
  (
    { row: { list, id }, hasInput, inputValue, option, onChange, onKeyDown },
    ref,
  ) => {
    const autocomplete = inputValue.trim()
      ? option.slice(inputValue.length)
      : '';

    return (
      <StrictModeDroppable droppableId={id} direction="horizontal">
        {(provided) => (
          <List {...provided.droppableProps} ref={provided.innerRef}>
            {list.map((item, index) => {
              if (index === list.length - 1 && hasInput) {
                return (
                  <Input key={item.id}>
                    <TextField
                      placeholder="Select metrics and write your formula"
                      autoComplete="off"
                      value={inputValue}
                      onChange={onChange}
                      onKeyDown={onKeyDown}
                      inputRef={ref}
                    />
                    <Mask>
                      <InputText>{inputValue}</InputText>
                      <span>{autocomplete}</span>
                    </Mask>
                  </Input>
                );
              }

              return (
                <Item
                  key={item.id}
                  index={index}
                  item={item}
                  icon={getIconForMetric(item.connectorType)}
                />
              );
            })}

            {provided.placeholder}
          </List>
        )}
      </StrictModeDroppable>
    );
  },
);
